// extracted by mini-css-extract-plugin
export default {"mainContainer":"NotFound_mainContainer__-XWvp","errorNumber":"NotFound_errorNumber__5LmsZ","errorText":"NotFound_errorText__dP+wv","button":"NotFound_button__tmXsI"};